import { resourceFilter } from '@/shared/components/registration/ResourceAutoComplete';
import angular from 'angular';

angular.module('cloudX').filter('regResourceSearch', [regResourceSearchFilter]);

function regResourceSearchFilter() {
  return function(array, searchOptions, current = null) {
    if (!angular.isArray(array)) {
      return array;
    }
    const currentId = current?.id ?? current;

    return array.filter(item => {
      return resourceFilter(item, searchOptions, currentId && currentId === item.id);
    });
  };
}
